import React from 'react';
import { Text } from '@chakra-ui/react';
import { ApolloError as Error } from '@apollo/client';

import { parseApolloError } from '../support/graphql/errorHandling';

type Props = {
  error: Error;
};

export function ApolloError(props: Props) {
  const { error } = props;
  const errorMessage = parseApolloError(error);
  return <Text>{errorMessage}</Text>;
}
